import { State, ACCOUNT_FEATURE_KEY } from './account.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getAccountState =
  createFeatureSelector<State>(ACCOUNT_FEATURE_KEY);
export const getPaymentMethods = createSelector(
  getAccountState,
  state => state.paymentMethods
);
export const getProfile = createSelector(
  getAccountState,
  state => state.profile
);
export const getAddress = createSelector(
  getAccountState,
  state => state.address
);
export const getConsultations = createSelector(
  getAccountState,
  state => state.consultations
);
export const getAppointments = createSelector(
  getAccountState,
  state => state.appointments
);

export const getPrescriptions = createSelector(
  getAccountState,
  state => state.prescriptions
);

// return true if any of the objects under account has loading attribute to true
export const isLoading = createSelector(getAccountState, state =>
  Object.keys(state).some(key => state[key].loading)
);

export const isShowAddPaymentMethod = createSelector(
  getAccountState,
  state => state.paymentMethods.showAddPaymentMethod
);
